import { fetchAuthSession } from "aws-amplify/auth";
import { post, put } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import {
  MENTAL_HEALTH_LIST_QUERY_KEY,
  MENTAL_HEALTH_TODAY_QUERY_KEY,
} from "./useMentalHealthQuery";

export const useMentalHealthPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "hrmentalhealthapi",
        path: "/",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: (vars) => {
      console.log('useMentalHealthPostMutation', vars)
      queryClient.invalidateQueries({
        queryKey: [MENTAL_HEALTH_LIST_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [MENTAL_HEALTH_TODAY_QUERY_KEY],
      });
    },
  });
};

export const useMentalHealthPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "hrmentalhealthapi",
        path: "/",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MENTAL_HEALTH_LIST_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [MENTAL_HEALTH_TODAY_QUERY_KEY],
      });
    },
  });
};
